import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBrandState } from '../../interfaces/state.interfaces';
import { IBrand } from '../../interfaces/brand.interface';

const initialState: IBrandState = {
    userBrands: [],
    activeBrand: null,
};

const brandSlice = createSlice({
    name: 'brand',
    initialState,
    reducers: {
        SetUserBrands(state, action: PayloadAction<IBrand[]>) {
            state.userBrands = action.payload;
        },
        SetActiveBrand(state, action: PayloadAction<IBrand | null>) {
            state.activeBrand = action.payload;
        },
        SetActiveBrandUrl(state, action: PayloadAction<string | null>) {
            if (state.activeBrand) {
                state.activeBrand.url = action.payload;
            }
        },
        SetBrandInitialState(state) {
            state.userBrands = [];
            state.activeBrand = null;
        },
        SetActiveBrandOnBoardedStatus(state, action: PayloadAction<boolean>) {
            if (state.activeBrand) {
                state.activeBrand.onBoardedStatus = action.payload;
            }
        },
    },
});

export const {
    SetActiveBrand,
    SetBrandInitialState,
    SetActiveBrandUrl,
    SetUserBrands,
    SetActiveBrandOnBoardedStatus,
} = brandSlice.actions;

export const brandReducer = brandSlice.reducer;
